/* External */
import { memo } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';

/* Components */
import PinLogin from './PinLogin';
import WelcomePage from './WelcomePage';
import CreateAccount from './CreateAccount/CreateAccount';

/* Utils */
import { getPath, Routes, getLink } from '../../utils/router';

function Public() {
  return (
    <Switch>
      <Route path={getPath(Routes.Public.PinLogin)} component={PinLogin} />
      <Route path={getPath(Routes.Public.WelcomePage)} component={WelcomePage} />
      <Route path={getPath(Routes.Public.CreateAccount)} component={CreateAccount} />
      <Redirect to={getLink(Routes.Public.WelcomePage)} />
    </Switch>
  );
}

export default memo(Public);
